import React from "react";
import { useAuth } from "../contexts/AuthContext";
import PostJobForm from "../jobs/PostJobForm";
import SignInForm from "../authentication/SignInForm";

export default function PostJob() {
  const { currentUser } = useAuth();
  return <>{currentUser ? <PostJobForm /> : <SignInForm />}</>;
}
